
export enum EmailRecipientTypeEnum {
    To = 1,
    Cc = 2,
    Bcc = 3
}

export enum SelectVesselTypeEnum {
    MissingPsc = 'missing-psc',
    ClassStatusReport = 'class-status-report',
    ChangeOfManagement = 'change-of-management'
}